import { render, staticRenderFns } from "./AgeInput.vue?vue&type=template&id=23bb8fc6"
import script from "./AgeInput.vue?vue&type=script&lang=ts"
export * from "./AgeInput.vue?vue&type=script&lang=ts"
import style0 from "./AgeInput.vue?vue&type=style&index=0&id=23bb8fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports